// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__7DRIr","expireStore_wrap":"layout_expireStore_wrap__3wBzV"};